import { render } from "./RoundEdit.vue?vue&type=template&id=3b47b54e"
import script from "./RoundEdit.vue?vue&type=script&lang=js"
export * from "./RoundEdit.vue?vue&type=script&lang=js"
script.render = render

export default script